import React from "react";
import classNames from "classnames";
import { SVGWiFi, SVGTv, SVGInfo, SVGConnect, SVGActions } from "Constants/SVG";
import { Tooltip, TooltipHeader, TooltipBody } from "ComponentsUI/Tooltip";
import BaseRow from "../BaseRow";

export default class DodyRow extends BaseRow {
	generateAddServicesOfTarifs() {
		let classes = this.props.classes;
		return this.props.data.map((item, index) => {
			return (
				<div key={index} className={classes.cell}>
					<div className={classes.cellIconsList}>{this._renderDoDy(item.dody, index)}</div>
				</div>
			);
		});
	}

	_renderDoDy(dody, index) {
		let classes = this.props.classes;
		let visibleDody = [],
			invisibleDody = [];
		let texts = this.props.text;
		let tariff = this.props.data[index];
		let connectText = !!tariff.connection?.price
			? `${tariff.connection.price} ${texts.SERVICES_RUB}`
			: texts.servicesFree;
		let prepaidText = tariff.price.system_calculation_connect
			? `${texts.AVANS} ${tariff.price.system_calculation_connect} ${texts.SERVICES_RUB}`
			: "";
		if (dody) {
			return dody.map((item, index) => {
				let textTooltip =
					index === 3 ? `${connectText} <br> ${prepaidText}` : item.short_description || "";
				textTooltip = <div dangerouslySetInnerHTML={{ __html: textTooltip }} />;
				return (
					<Tooltip
						key={index}
						position={`top`}
						openClick={true}
						windowSizeModel={this.props.windowSizeModel}
						header={<TooltipHeader text={index === 3 ? texts.servicesConnect : item.name} />}
						body={<TooltipBody>{textTooltip}</TooltipBody>}
					>
						<div
							className={classNames(classes.cellIconsItem, {
								[classes.svgGrey]: !item.state,
								[classes.svgGreen]: item.state === 1 || index === 3,
								[classes.svgPurple]: item.state === 2,
							})}
						>
							{index === 0 && SVGWiFi}
							{index === 1 && SVGTv}
							{index === 2 && SVGInfo}
							{index === 3 && SVGConnect}
							{index === 4 && SVGActions}
						</div>
					</Tooltip>
				);
			});
		} else {
			return null;
		}
	}

	render() {
		let classes = this.props.classes;
		let columns = {
			2: [classes.rowColNumber2],
			3: [classes.rowColNumber3],
			4: [classes.rowColNumber4],
			5: [classes.rowColNumber5],
			6: [classes.rowColNumber6],
		};
		let style = {
			transform: `translateX(${this.props.moveValue}px)`,
		};

		return (
			<div className={classNames(classes.row, columns[this.props.columns])}>
				<div className={classes.headerCell} style={style}>
					<div className={classes.headerCellText}>{this.props.header}</div>
				</div>
				<div className={classes.cellsWrapper}>{this.generateAddServicesOfTarifs()}</div>
			</div>
		);
	}
}
